import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PARTS } from './consts';

const AvatarWrapper = styled.div`
  width: 49%;
  position: relative;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Avatar = ({ config, className }) => {
  const {
    headShape,
    headShapeColor,
    eyes,
    eyesColor,
    eyebrows,
    eyebrowsColor,
    eyewear,
    top,
    topColor,
    hairstyle,
    hairstyleColor,
    beak,
    beakColor
  } = config;

  return (
    <AvatarWrapper className={className}>
      {PARTS.HEAD_SHAPE(headShapeColor)[headShape]}
      {PARTS.EYES(eyesColor)[eyes]}
      {PARTS.EYEBROWS(eyebrowsColor)[eyebrows]}
      {PARTS.EYEWEAR()[eyewear]}
      {PARTS.TOP(topColor)[top]}
      {PARTS.HAIRSTYLE(hairstyleColor)[hairstyle]}
      {PARTS.BEAK(beakColor)[beak]}
    </AvatarWrapper>
  );
};

Avatar.propTypes = {
  config: PropTypes.object,
  className: PropTypes.string
};

export default Avatar;
